import { useMemo } from "react";
import { BookOpen, Calculator, FlaskConical } from "lucide-react";

const SUBJECT_ICON = { Mathematics: Calculator, English: BookOpen, Science: FlaskConical };

export default function TryTopicGrid({ topics, onSelect }) {
  const grouped = useMemo(() => {
    const map = {};
    for (const t of topics || []) {
      const key = `${t.grade} · ${t.subject}`;
      (map[key] = map[key] || []).push(t);
    }
    return map;
  }, [topics]);

  return (
    <div className="fade-up" data-testid="try-topic-grid">
      <h3 className="font-display text-xl font-bold text-slate-800 mb-1">Pick a topic</h3>
      <p className="text-sm text-slate-500 mb-5">
        Choose any topic below to explore its recap, warm up, and practice.
      </p>
      <div className="space-y-6">
        {Object.entries(grouped).map(([group, items]) => (
          <div key={group}>
            <div className="text-xs font-semibold uppercase tracking-wider text-sky-600 mb-2" data-testid={`try-topic-group-${group}`}>
              {group}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {items.map((t) => {
                const Icon = SUBJECT_ICON[t.subject] || BookOpen;
                return (
                  <button
                    key={`${t.grade}-${t.subject}-${t.sub_topic}`}
                    type="button"
                    onClick={() => onSelect(t)}
                    data-testid={`try-topic-card-${t.sub_topic.replace(/\s+/g, "-").toLowerCase()}`}
                    className="text-left p-4 rounded-2xl border-2 border-slate-200 bg-white hover:border-sky-300 hover:bg-sky-50 transition-colors tap-44"
                  >
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 rounded-xl bg-sky-100 flex items-center justify-center shrink-0">
                        <Icon className="w-4 h-4 text-sky-600" />
                      </div>
                      <div>
                        <div className="font-semibold text-slate-800 text-sm">{t.sub_topic}</div>
                        <div className="text-xs text-slate-500 mt-0.5">
                          {t.topic} · {t.question_count} questions{t.has_diagrams ? " · has diagrams" : ""}
                        </div>
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
